import { useMutation } from '@tanstack/react-query';
import { BizApi } from 'api';

/**
 * [Biz] SMS 전송
 * --
 */
export const useBizSendSMS = () => {
  const { mutateAsync: sendSMS, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizSendSMS(variables),
  });

  return { sendSMS, ...result };
};

/**
 * [Biz] LMS 전송
 * --
 */
export const useBizSendLMS = () => {
  const { mutateAsync: sendLMS, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizSendLMS(variables),
  });

  return { sendLMS, ...result };
};

/**
 * [Biz] MMS 전송
 * --
 */
export const useBizSendMMS = () => {
  const { mutateAsync: sendMMS, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizSendMMS(variables),
  });

  return { sendMMS, ...result };
};

/**
 * [Biz] 알림톡 전송
 * --
 */
export const useBizSendKakaoAt = () => {
  const { mutateAsync: sendKakaoAt, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizSendKakaoAt(variables),
  });

  return { sendKakaoAt, ...result };
};

/**
 * [Biz] 이미지 알림톡 전송
 * --
 */
export const useBizSendKakaoAi = () => {
  const { mutateAsync: sendKakaoAi, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizSendKakaoAi(variables),
  });

  return { sendKakaoAi, ...result };
};

/**
 * [Biz] 이미지 알림톡 전송
 * --
 */
export const useBizFileUpload = () => {
  const { mutateAsync: fileUpload, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizFileUpload(variables),
  });

  return { fileUpload, ...result };
};

/**
 * [Biz] 템플릿 등록
 * --
 */
export const useBizTemplateAdd = () => {
  const { mutateAsync: bizTemplateAdd, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateAdd(variables),
  });

  return { bizTemplateAdd, ...result };
};

/**
 * [Biz] 템플릿 코드 유효성 검증
 * --
 */
export const useBizTemplateCodeCheck = () => {
  const { mutateAsync: bizTemplateCodeCheck, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateCodeCheck(variables),
  });

  return { bizTemplateCodeCheck, ...result };
};

/**
 * [Biz] 템플릿 목록 조회
 * --
 */
export const useBizTemplateList = () => {
  const { mutateAsync: bizTemplateList, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateList(variables),
  });

  return { bizTemplateList, ...result };
};

/**
 * [Biz] 템플릿 상세조회
 * --
 */
export const useBizTemplateDetail = () => {
  const { mutateAsync: bizTemplateDetail, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateDetail(variables),
  });

  return { bizTemplateDetail, ...result };
};

/**
 * [Biz] 템플릿 수정
 * --
 */
export const useBizTemplateUpdate = () => {
  const { mutateAsync: bizTemplateUpdate, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateUpdate(variables),
  });

  return { bizTemplateUpdate, ...result };
};

/**
 * [Biz] 템플릿 삭제
 * --
 */
export const useBizTemplateDelete = () => {
  const { mutateAsync: bizTemplateDelete, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateDelete(variables),
  });

  return { bizTemplateDelete, ...result };
};

/**
 * [Biz] 템플릿 카테고리 전체 조회
 * --
 */
export const useBizTemplateCategoryAll = () => {
  const { mutateAsync: bizTemplateCategoryAll, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateCategoryAll(variables),
  });

  return { bizTemplateCategoryAll, ...result };
};

/**
 * [Biz] 템플릿 카테고리 단일 조회
 * --
 */
export const useBizTemplateCategory = () => {
  const { mutateAsync: bizTemplateCategory, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateCategory(variables),
  });

  return { bizTemplateCategory, ...result };
};

/**
 * [Biz] 템플릿 검수 요청
 * --
 */
export const useBizTemplateRequest = () => {
  const { mutateAsync: bizTemplateRequest, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateRequest(variables),
  });

  return { bizTemplateRequest, ...result };
};

/**
 * [Biz] 템플릿 검수 요청 취소
 * --
 */
export const useBizTemplateRequestCancel = () => {
  const { mutateAsync: bizTemplateCancelRequest, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateCancelRequest(variables),
  });

  return { bizTemplateCancelRequest, ...result };
};

/**
 * [Biz] 템플릿 사용 중지
 * --
 */
export const useBizTemplateStop = () => {
  const { mutateAsync: bizTemplateStop, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateStop(variables),
  });

  return { bizTemplateStop, ...result };
};

/**
 * [Biz] 템플릿 사용 중지 해제
 * --
 */
export const useBizTemplateReuse = () => {
  const { mutateAsync: bizTemplateReuse, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateReuse(variables),
  });

  return { bizTemplateReuse, ...result };
};

/**
 * [Biz] 템플릿 승인 취소
 * --
 */
export const useBizTemplateApproval = () => {
  const { mutateAsync: bizTemplateCancelApproval, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateCancelApproval(variables),
  });

  return { bizTemplateCancelApproval, ...result };
};

/**
 * [Biz] 템플릿 휴먼 해제
 * --
 */
export const useBizTemplateRelease = () => {
  const { mutateAsync: bizTemplateRelease, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateRelease(variables),
  });

  return { bizTemplateRelease, ...result };
};

/**
 * [Biz] 템플릿 휴먼 해제
 * --
 */
export const useBizTemplateConvertAddCh = () => {
  const { mutateAsync: bizTemplateConvertAddCh, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateConvertAddCh(variables),
  });

  return { bizTemplateConvertAddCh, ...result };
};

/**
 * [Biz] 템플릿 변환
 * --
 */
export const useBizTemplateReplace = () => {
  const { mutateAsync: bizTemplateReplace, ...result } = useMutation({
    mutationFn: (variables) => BizApi.bizTemplateReplace(variables),
  });

  return { bizTemplateReplace, ...result };
};
